module.exports = __webpack_public_path__ + "cfc777335075f937f20ede328e50f6ef.MP3";